// extracted by mini-css-extract-plugin
module.exports = {"container":"xR0PaNFg","inputContainer":"qSvu3Q9v","inputLabel":"OZF9SGkx","styledInput":"Ct_jkNgJ","buttonContainer":"spOyq9i0"};